import { render } from "./Home.vue?vue&type=template&id=f67beb64&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=f67beb64&scoped=true&lang=css"

import exportComponent from "/opt/qyxs/qinyan_pro/qinyan_pro_client/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f67beb64"]])

export default __exports__